module.exports = __webpack_public_path__ + "img/web.17d7c9d6.svg";